export const types = {
    GET_CANDIDATOS_REQUEST: "aprobaciones/GET_CANDIDATOS_REQUEST",
    GET_CANDIDATOS_SUCCESS: "aprobaciones/GET_CANDIDATOS_SUCCESS",
    GET_CANDIDATOS_ERROR: "aprobaciones/GET_CANDIDATOS_ERROR",

    GET_SOLICITUDES_REQUEST: "aprobaciones/GET_SOLICITUDES_REQUEST",
    GET_SOLICITUDES_SUCCESS: "aprobaciones/GET_SOLICITUDES_SUCCESS",
    GET_SOLICITUDES_ERROR: "aprobaciones/GET_SOLICITUDES_ERROR",

    GET_BLOQUEO_REQUEST: "aprobaciones/GET_BLOQUEO_REQUEST",
    GET_BLOQUEO_SUCCESS: "aprobaciones/GET_BLOQUEO_SUCCESS",
    GET_BLOQUEO_ERROR: "aprobaciones/GET_BLOQUEO_ERROR",

    SOLICITAR_APROBACION_REQUEST: "aprobaciones/SOLICITAR_APROBACION_REQUEST",
    SOLICITAR_APROBACION_SUCCESS: "aprobaciones/SOLICITAR_APROBACION_SUCCESS",
    SOLICITAR_APROBACION_ERROR: "aprobaciones/SOLICITAR_APROBACION_ERROR",

    VOTAR_APROBACION_REQUEST: "aprobaciones/VOTAR_APROBACION_REQUEST",
    VOTAR_APROBACION_SUCCESS: "aprobaciones/VOTAR_APROBACION_SUCCESS",
    VOTAR_APROBACION_ERROR: "aprobaciones/VOTAR_APROBACION_ERROR",

    CLEAR_STATE: "aprobaciones/CLEAR_STATE",
};

export const actions = {
    getCandidatos: (proyectoId) => ({ type: types.GET_CANDIDATOS_REQUEST, proyectoId }),
    getSolicitudes: (proyectoId) => ({ type: types.GET_SOLICITUDES_REQUEST, proyectoId }),
    getBloqueo: (proyectoId, moduloTipo, referenciaId) => ({ type: types.GET_BLOQUEO_REQUEST, proyectoId, moduloTipo, referenciaId }),
    solicitarAprobacion: (proyectoId, payload, onSuccess) => ({ type: types.SOLICITAR_APROBACION_REQUEST, proyectoId, payload, onSuccess }),
    votarAprobacion: (solicitudId, payload, proyectoId, onSuccess) => ({ type: types.VOTAR_APROBACION_REQUEST, solicitudId, payload, proyectoId, onSuccess }),
    clearState: () => ({ type: types.CLEAR_STATE }),
};

const defaultState = {
    isLoading: false,
    candidatos: [],
    solicitudes: [],
    bloqueosPorModulo: {}, // { [moduloTipo]: { bloqueado: boolean, estado: string, solicitud: obj } }
    error: null,
};

export const selectors = {
    getIsLoading: ({ aprobaciones }) => aprobaciones.isLoading,
    getCandidatos: ({ aprobaciones }) => aprobaciones.candidatos,
    getSolicitudes: ({ aprobaciones }) => aprobaciones.solicitudes,
    getBloqueosPorModulo: ({ aprobaciones }) => aprobaciones.bloqueosPorModulo,
    getError: ({ aprobaciones }) => aprobaciones.error,
};

const aprobacionesReducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case types.GET_CANDIDATOS_REQUEST:
        case types.GET_SOLICITUDES_REQUEST:
        case types.SOLICITAR_APROBACION_REQUEST:
        case types.VOTAR_APROBACION_REQUEST:
            return { ...state, isLoading: true, error: null };

        case types.GET_CANDIDATOS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                candidatos: action.payload || [],
                error: null,
            };

        case types.GET_SOLICITUDES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                solicitudes: action.payload || [],
                error: null,
            };

        case types.GET_BLOQUEO_SUCCESS:
            return {
                ...state,
                bloqueosPorModulo: {
                    ...state.bloqueosPorModulo,
                    [action.moduloTipo]: action.payload,
                },
            };

        case types.SOLICITAR_APROBACION_SUCCESS:
        case types.VOTAR_APROBACION_SUCCESS:
            return { ...state, isLoading: false, error: null };

        case types.GET_CANDIDATOS_ERROR:
        case types.GET_SOLICITUDES_ERROR:
        case types.GET_BLOQUEO_ERROR:
        case types.SOLICITAR_APROBACION_ERROR:
        case types.VOTAR_APROBACION_ERROR:
            return { ...state, isLoading: false, error: action.error };

        case types.CLEAR_STATE:
            return { ...defaultState };

        default:
            return state;
    }
};

export default aprobacionesReducer;
